import { useContext } from 'react';
import { LocaleContext, type LocaleContextValue } from './LocaleProvider';

export const useT = (): LocaleContextValue => {
  const context = useContext(LocaleContext);
  if (!context) throw new Error('useT must be used inside <LocaleProvider>');
  return context;
};
